import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { initTracking, identify, page } from './track';

/* Glue between React and the first-party analytics SDK (utils/track.ts):
 *  - inits the global click listener + flush-on-hide once,
 *  - fires a page_view (with prior-page dwell) on every route change,
 *  - (re)identifies on login/logout.
 * Renders nothing. Mounted once in App, alongside RouteAnalytics, inside both the
 * Router (useLocation) and UserProvider (useUser). */
export const Analytics = () => {
  const location = useLocation();
  const { user } = useUser();

  useEffect(() => {
    initTracking();
  }, []);

  useEffect(() => {
    identify(user && user.id ? Number(user.id) : null);
  }, [user]);

  useEffect(() => {
    page(location.pathname);
  }, [location.pathname]);

  return null;
};

export default Analytics;
